// The one wording a passenger agrees to. The booking form, the passenger app and the public opt-in
// proof page a carrier reviews all read it from here, so the proof page can never drift from the
// checkbox a passenger actually ticks.
export const SMS_CONSENT_TEXT =
  "Text me trip updates at this number. Up to ~6 messages per trip. Message and data rates may apply. Reply STOP to opt out, HELP for help.";
